import React from 'react'
import styled from 'styled-components'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const FilterSearchIcon = () => (
  <IconContainer>
    <svg xmlns="http://www.w3.org/2000/svg" width="110" height="31" viewBox="0 0 110 31">
      <g id="filter_search" transform="translate(959 -9391)">
        <g className="strokeHoverSVG" id="Rectangle_2893" data-name="Rectangle 2893" transform="translate(-959 9391)" fill="none" stroke="#787878" strokeWidth="2">
          <rect width="110" height="31" rx="5" stroke="none"/>
          <rect x="1" y="1" width="108" height="29" rx="4" fill="none"/>
        </g>
        <path className="fillHoverSVG" id="Icon_awesome-search" data-name="Icon awesome-search" d="M11.72,10.274,9.406,7.96A.557.557,0,0,0,9.012,7.8H8.633a4.825,4.825,0,1,0-.835.835v.378a.557.557,0,0,0,.162.395l2.314,2.314a.555.555,0,0,0,.787,0l.657-.657a.56.56,0,0,0,0-.789ZM4.827,7.8A2.971,2.971,0,1,1,7.8,4.827,2.969,2.969,0,0,1,4.827,7.8Z" transform="translate(-871.762 9400.559)" fill="#707070"/>
      </g>
    </svg>
  </IconContainer>
)

export default FilterSearchIcon